module.exports = __webpack_public_path__ + "static/media/purple_arrow.4b8fc9ea.svg";